/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import ModuloForm from './ModuloForm';
import * as validations from '../../validations/validations';
import * as moduloActions from '../../actions/moduloActions';
import * as tablasActions from '../../actions/tablasActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
import $ from 'jquery';
import withRouter from '../common/withRouter'; 



import * as tagActions from '../../actions/tagActions';
import * as contenidoActions from '../../actions/contenidoActions';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as usuarioActions from '../../actions/usuarioActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';

import * as infoActions from '../../actions/infoActions';


class ManageModuloForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
             headersTablaContenidos:["Editar","Orden","Agrupador", "Contenido","Instructor" ,"Fecha"],
            camposTablaContenidos:["idContenido", "orden" , "agrupador" , "idContenido","idUsuario", "fecha2"],
            validacionesTablaContenidos:[
                        {"name":"orden", "type":"int","max":1000,"min":0}
            ],
            tipoTablaContenidos:["button","input", "input","combo","combo", "sigleDate"],
            errors:{},
            permisos:{},
            test:0,
			modulo:{
                fecha2: new moment().format('DD/MM/YYYY')
                    }
		};
		
	}
    
    fechas=(fechasArreglo, fechasCadena)=>{
    
            let modulo = this.state.modulo;
            modulo.fechaPresentacion = fechasArreglo;
            this.setState({modulo:modulo});
    }
    
    
     getTabla=(nombre)=>{
         
          let tabla=[...this.props.tablas.filter(tabla => tabla.nombre == nombre)];
        
        if(tabla.length>0){
            return tabla[0].rows;
        }
        return [];
    }
    componentDidMount(){
        
         usuarioActual(this, "modulo",true).then( (usuario)=>{
           let id=this.props.id;
        
                this.props.tagActions.getTagCombo(usuario).then( ()=>{ 
           
               }) 
                .catch(error=>{ 
                  toastr.error(error); 
                }); 

                /*
                this.props.contenidoActions.getArchivosDisponibles(29, usuario).then( archivos=>{
                   this.setState({"archivos":archivos});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
                */
             
                this.props.contenidoActions.getContenidoComboAndTipo(usuario).then( ()=>{ 

               }) 
                .catch(error=>{ 
                  toastr.error(error); 
                }); 
             
             
                this.props.usuarioActions.getUsuarioCombo(14,usuario).then( ()=>{ 

               }) 
                .catch(error=>{ 
                  toastr.error(error); 
                }); 
             
        
             
            if(id && id>0 ){
                   this.props.moduloActions.getModulo(id, usuario).then( modulo=>{
                       
                       
                       for(let i=0; i<modulo.idsContenidos.length; i++){
                           //console.log(modulo.idsContenidos[i].fecha2);
                           modulo.idsContenidos[i].fecha2  = new moment(modulo.idsContenidos[i].fecha2); 
                           
                           //if(moment.isMoment(modulo.idsContenidos[i].fecha2)){
                            //   //console.log("si es moment");
                           //}else{
                            //   //console.log("no es moment");
                         //  }
                           
                        //   //console.log(modulo.idsContenidos[i].fecha2);
                           
                       }
                       
                     
                       this.props.contenidoActions.getArchivosDisponibles(29, this.props.user, modulo.prefijo).then( archivos=>{
                           this.setState({"archivos":archivos});
                       })
                        .catch(error=>{
                          toastr.error(error);
                        }); 
                       
                       
                       
                       this.setState({"modulo":modulo});
                    //debugger;
                       let tabla={
                            "nombre":"idsContenidos",
                            "rows":modulo.idsContenidos
                        };
                       
                     
                       
                        this.props.tablasActions.update(tabla);
                       
                   })
                    .catch(error=>{
                      toastr.error(error);
                    }); 
                }else{
                
                    let tabla={
                        "nombre":"idsContenidos",
                        "rows":[]
                    };
                    this.props.tablasActions.update(tabla);
                }
             
       })
        .catch(error=>{
          toastr.error(error);
        }); 
		
  

        
        
		
    }


    componentWillReceiveProps(nextProps) {	
         let test = this.state.test;
        
        let sizeProps = 0;
        let sizeNext = 0;
        
        
        let indexProps = this.props.tablas.findIndex(p=>p.nombre=='idsContenidos');
        
        let indexNext = nextProps.tablas.findIndex(n=>n.nombre=='idsContenidos');
        
        
        if(indexProps >-1 && indexNext >-1){
            
           
            
            sizeProps = this.props.tablas[indexProps].rows.length;
            sizeNext = nextProps.tablas[indexNext].rows.length;
            
            if(sizeProps!=sizeNext){
                test=1;
                this.setState({test:test});
                this.props.tablasActions.update(nextProps.tablas[indexNext]);
            }
            
            
        }
   
	  
	}
    

    onBuscar=(event)=>{
        event.preventDefault();
        let modulo = this.state.modulo;
        
        if( modulo.prefijo!=""){
            this.props.contenidoActions.getArchivosDisponibles(29, this.props.user, modulo.prefijo).then( archivos=>{
               this.setState({"archivos":archivos});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
    }


    handleChange=(event, data)=> {

        let modulo = this.state.modulo;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		modulo[field[0]]= value;
		else{
             if(!modulo[field[0]]){
                    modulo[field[0]]={}
                }
			modulo[field[0]][field[1]]= value;
		}
        
		
        this.setState({"modulo": modulo});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let modulo=this.state.modulo;
              
        if(!validations.requerido(modulo.titulo)){
            errors.titulo=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(modulo.descripcion)){
            errors.descripcion=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(modulo.imagen)){
            errors.imagen=true;
            formIsValid=false;
        }
       /*
        if(!validations.requerido(modulo.idsContenidos)){
            errors.idsContenidos=true;
            formIsValid=false;
        }*/
       
        if(!validations.requerido(modulo.idsTags)){
            errors.idsTags=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }

    goBack=()=>{
         this.props.navigate(-1);
    }


    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
         let newState=Object.assign({}, this.state.modulo);
        
        
        if(moment.isMoment(newState.fechaPresentacion)){
            newState.fechaPresentacion = new moment(newState.fechaPresentacion).format('DD/MM/YYYY');
        }else{
            newState.fechaPresentacion = moment(newState.fechaPresentacion, 'DD/MM/YYYY'); 
            newState.fechaPresentacion = new moment(newState.fechaPresentacion).format('DD/MM/YYYY');
        }
        
       
        newState.idsContenidos=this.getTabla("idsContenidos");
        
        for(let i=0; i<newState.idsContenidos.length;i++){
            
            newState.idsContenidos[i].fecha2=new moment(newState.idsContenidos[i].fecha2).format('YYYY/MM/DD hh:mm:ss');
        }
        
        
        
        this.props.moduloActions.save(newState, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            this.props.history.goBack();
            //this.props.history.push('/modulos');
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <ModuloForm 
                    user={this.props.user}
                    infoActions={this.props.contenidoActions}
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.modulo}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    archivos={genericFormattedForDropdown(this.state.archivos)}
            
                    headersTablaContenidos={this.state.headersTablaContenidos}
                    camposTablaContenidos={this.state.camposTablaContenidos}
                    validacionesTablaContenidos={this.state.validacionesTablaContenidos}
                    tipoTablaContenidos={this.state.tipoTablaContenidos}

                    tagCombo={genericFormattedForDropdown(this.props.tagCombo)}
                    contenidoCombo={genericFormattedForDropdown(this.props.contenidoCombo)}
                    contenidoComboTipo={this.props.contenidoCombo}
                    comboInstructor={genericFormattedForDropdown(this.props.usuarioCombo)}
                    
                    fechas={this.fechas}
                    onBuscar={this.onBuscar}
                    goBack={this.goBack}
                    test={this.state.test}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    //let id = ownProps.match.params.id;
    
    return {        
            ajaxCallInProgress:state.ajaxCallInProgress,
            
            showSidebarIzquierda: state.showSidebarIzquierda,
            sidebarIzquierda: state.sidebarIzquierda, 
            color:state.color,
            user:state.user, 
            idioma:state.idioma,
            form:state.form,
            tagCombo:state.tagCombo,
            tablas:state.tablas,
            contenidoCombo:state.contenidoCombo,
            usuarioCombo:state.usuarioCombo,
            strings:state.strings,
    }

}

function mapDispatchToProps(dispatch){

	return {
        infoActions: bindActionCreators(infoActions, dispatch),
        userActions:bindActionCreators(userActions, dispatch),
        menuActions:bindActionCreators(menuActions, dispatch),
        tablasActions: bindActionCreators(tablasActions, dispatch),
        contenidoActions: bindActionCreators(contenidoActions, dispatch),
        tagActions: bindActionCreators(tagActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        moduloActions: bindActionCreators(moduloActions, dispatch),
        usuarioActions: bindActionCreators(usuarioActions, dispatch)
	};
}

export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageModuloForm));